import { render, staticRenderFns } from "./EditOutOfOffice.vue?vue&type=template&id=137e967a&"
import script from "./EditOutOfOffice.vue?vue&type=script&lang=js&"
export * from "./EditOutOfOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137e967a')) {
      api.createRecord('137e967a', component.options)
    } else {
      api.reload('137e967a', component.options)
    }
    module.hot.accept("./EditOutOfOffice.vue?vue&type=template&id=137e967a&", function () {
      api.rerender('137e967a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/EditOutOfOffice.vue"
export default component.exports